import { gql } from '@apollo/client';

export const CREATE_LEARNING_OBJECT_MUTATION = gql`
    mutation createLearningObject($input: CreateLearningObjectInput!) {
        result: createLearningObject(input: $input) {
            id
            tags
            format
            duration
            locales {
                locale
                name
                description
            }
            assets {
                edges {
                    isDefault
                    node {
                        id
                        name
                        url
                        mimetype
                        encoding
                        createdAt
                        updatedAt
                        locales
                    }
                }
            }
            createdAt
            __typename
        }
    }
`;

// input CreateLearningObjectInput {
//     id: UUID!
//     locales: [LearningObjectLocaleInput!]!
//     duration: Int
//     format: String!
//     tags: [String!]
//     assets: [CreateLearningObjectAssetsInput!]!
// }
